import { styled } from "styled-components";

export const Container = styled.div`
  width: 1000px;
  max-width: 100%;
  margin: 0 auto;
  `;
